import * as $ from "jquery";
import {confirmModal} from "../confirmModal";

export const events_page = () => {

    const body = $('body');
    const uuid = require('uuid/v4');

    $("#availableMembersList").DataTable({
        order: [2, 'asc'],
        stateSave: false,
        columnDefs: [
            {
                targets: [1, 2],
                type: 'polstring',
            }
        ]
    });

    if ($("#availableMembersList").length > 0) {
        $("#addEvent").submit(function (e) {
            e.preventDefault();

            let inputs = $("#availableMembersList").DataTable().$('input');

            for (let input of inputs) {

                if ($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="users_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    $("#inviteToEvent").submit(function (e) {
        e.preventDefault();
        let checkboxes = $('#members').DataTable().api().checkedCheckboxes();

        for (let checkbox of checkboxes) {
            $(this).append($(checkbox).clone().attr('type', 'hidden'));
            $(checkbox).attr('name', 'member_old[]');
        }

        this.submit();
    })

    $("#members").DataTable({
        stateSave: false,
        order: [2, 'asc'],
        columnDefs: [
            {
                targets: [1, 2],
                type: 'polstring'
            }
        ]
    })

    $("#timesheet").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
        columnDefs: [
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ]
    })

    $("#eventList").DataTable({
        "order": [[0, "desc"]],
        "stateSave": false,
    })

    $(function () {
       if($('[name="event_type_id"]').val() !== '4'){
           $('.generate').hide();
       }

        if($('[name="duration"]').val() === null || $('[name="duration"]').val() === ''){
            $('[name="duration"]').val(1);
        }
    });

    $('[name="event_type_id"]').change(function () {
        if ($(this).val() === '4') {
            $('.generate').show();
        } else {
            $('.generate').hide();
        }
    }).change();

    function parseDateTime(dateTimeString) {
        let parts = dateTimeString.split(' ');
        let datePart = parts[0];
        let timePart = parts[1];

        let dateParts = datePart.split('/');
        let day = parseInt(dateParts[0], 10);
        let month = parseInt(dateParts[1], 10) - 1;
        let year = parseInt(dateParts[2], 10);

        let timeParts = timePart.split(':');
        let hours = parseInt(timeParts[0], 10);
        let minutes = parseInt(timeParts[1], 10);

        return new Date(year, month, day, hours, minutes);
    }

    let eventDetails = {};
    let eventsToInsert = [];

    generateEventTable(eventsToInsert);

    function checkFieldsFilled() {
        let duration = $('input[name="duration"]').val();
        let start = $('input[name="start"]').val();
        let end = $('input[name="end"]').val();

        if (duration && start && end) {

            eventDetails = {
                duration: duration,
                start: start,
                end: end
            }

            let startDateTime = parseDateTime($('input[name="start"]').val());
            let endDateTime = parseDateTime($('input[name="end"]').val());

            let durationInMilliseconds = endDateTime - startDateTime;

            // Convert milliseconds to hours
            let durationInHours = durationInMilliseconds / (1000 * 60 * 60);

            let eventsCount = durationInHours / duration;

            $('#events-count').val(eventsCount);

            let eventsData = $('#events-data').val();

            let startDate = new Date(startDateTime);
            let endDate = new Date(endDateTime);

            for (let i = 0; i < eventsCount; i++) {

                let startFormatted = startDate.toLocaleString();
                startDate.setTime(startDate.getTime() + durationInMilliseconds / eventsCount);
                let endFormatted = (startDate > endDate) ? endDate.toLocaleString() : startDate.toLocaleString();

                let newEvent = {
                    duration: duration,
                    start: startFormatted,
                    end: endFormatted,
                    uuid: uuid()
                };

                eventsToInsert = [...eventsToInsert, {
                    ...newEvent
                }];
            }

            updateEventsTable(eventsToInsert, eventsToInsert.length);
        }
    }

    function updateEventsTable(eventDetails, eventsCount) {
        let table = $('#generatedEventsTable').DataTable();

        table.api().columns.adjust().responsive.recalc();
        table.api().clear().rows.add(eventDetails).draw();

        $('#events-data').val(JSON.stringify(eventDetails));
        $('#events-count').val(eventsCount);

        // if (eventsCount > 0) {
        //     $('[name="event_type_id"]').prop('disabled', true);
        // } else {
        //     $('[name="event_type_id"]').prop('disabled', false);
        // }
    }

    function generateEventTable(eventDetails) {
        let table = $('#generatedEventsTable').DataTable({
            stateSave: false,
            columnDefs: [
                {
                    targets: 0,
                    data: 'start',
                },
                {
                    targets: 1,
                    data: 'end',
                },
                {
                    targets: 2,
                    data: null,
                    render: (data) => {
                        return `<button data-uuid="${data.uuid ?? ''}" 
                                class="btn btn-sm btn-danger btnDeleteGeneratedEvent" 
                                type="button">Usuń</button>`
                    }
                }
            ],
            drawCallback: function () {
                let inputs = this.$('span.input-wrapper');
                inputs.each(function () {
                    new bootstrap.Tooltip(this)
                })
            }
        });

        table.api().columns.adjust().responsive.recalc();
        table.api().clear().rows.add(eventDetails).draw();
    }

    $("#btnGenerateEventDuty").click(function () {
        checkFieldsFilled();
    });

    body.on('click', '.btnDeleteGeneratedEvent', async function () {
        let uuid = $(this).data('uuid');

        if (await confirmModal('Czy na pewno chcesz usunąć ten dyżur?', {color: 'danger'})) {
            let index;

            if (uuid.length > 0) {
                index = eventsToInsert.findIndex(el => el.uuid === uuid);
            }

            if (index !== -1) {
                eventsToInsert = eventsToInsert.filter((el, i) => i !== index)
            }

            updateEventsTable(eventsToInsert, eventsToInsert.length);

        }
    })
}
